/* Cart drawer natif Afrosphère.
   Moonbundle reste le moteur de promotions : ce fichier ne crée aucune remise,
   il rafraîchit seulement l'affichage à partir de ce que Shopify renvoie. */

(function () {
  'use strict';

  /* ================================================================
     Fluidité — contexte de rendu des sections
     ================================================================
     cart.js et product-form.js demandent le rendu partiel avec
     sections_url = window.location.pathname. Shopify rend alors TOUT le
     template en cours (accueil, collection, page produit, apps comprises)
     uniquement pour en extraire le tiroir : c'est l'essentiel de l'attente
     ressentie à chaque +/−, suppression ou ajout au panier.

     On réécrit ce seul paramètre au vol vers /cart, le template le plus léger
     qui contient la même section. Passer par fetch évite de modifier cart.js
     et product-form.js, qui restent d'origine (donc compatibles avec les
     futures mises à jour de Dawn). En cas de doute, on laisse partir la
     requête telle quelle : ce raccourci ne doit jamais casser un ajout. */
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const cartUrl = window.routes && window.routes.cart_url;
      const isCartWrite =
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/update') !== -1;
      if (cartUrl && isCartWrite && init && init.body) {
        if (typeof init.body === 'string' && init.body.indexOf('sections_url') !== -1) {
          const payload = JSON.parse(init.body);
          payload.sections_url = cartUrl;
          init = Object.assign({}, init, { body: JSON.stringify(payload) });
        } else if (
          typeof FormData !== 'undefined' &&
          init.body instanceof FormData &&
          init.body.has('sections_url')
        ) {
          init.body.set('sections_url', cartUrl);
        }
      }
    } catch (e) {
      /* comportement d'origine */
    }
    return nativeFetch.call(this, input, init);
  };

  /* ================================================================
     Fluidité — état d'attente non bloquant
     ================================================================
     Dawn fige la liste (.cart__items--disabled) et affiche un spinner plein
     cadre à chaque changement. On le remplace par un simple estompage des
     montants : la lecture n'est pas coupée et les boutons +/− restent
     cliquables pendant l'aller-retour.

     Ces règles concernent uniquement des états transitoires, jamais la mise en
     page : les garder ici plutôt que dans la feuille de style évite de toucher
     à component-cart-drawer-native.css, entièrement piloté par l'éditeur. */
  const busyStyles = document.createElement('style');
  busyStyles.textContent = [
    '.afs-drawer .loading__spinner{display:none !important;}',
    '.afs-drawer .cart__items--disabled{opacity:1;pointer-events:none;}',
    '.afs-drawer .cart__items--disabled .afs-qty,',
    '.afs-drawer .cart__items--disabled .afs-qty__button,',
    '.afs-drawer .cart__items--disabled .afs-qty__input{pointer-events:auto;}',
    '.afs-drawer .afs-item__price,',
    '.afs-drawer .afs-item__old-price,',
    '.afs-drawer .afs-item__badge,',
    '.afs-drawer .afs-subtotal__price,',
    '.afs-drawer .afs-discount-line__price{transition:opacity .12s ease;}',
    '.afs-drawer.afs-busy .afs-item__old-price,',
    '.afs-drawer.afs-busy .afs-item__badge,',
    '.afs-drawer.afs-busy .afs-subtotal__price,',
    '.afs-drawer.afs-busy .afs-discount-line__price{opacity:.4;}',
  ].join('');
  document.head.appendChild(busyStyles);

  function drawerElement() {
    return document.querySelector('cart-drawer');
  }

  function setBusy(state) {
    const drawer = drawerElement();
    if (drawer) drawer.classList.toggle('afs-busy', state);
  }

  /* La section vit dans le groupe d'en-tête, son identifiant de rendu est donc
     préfixé (sections--123__cart-drawer) et pas simplement "cart-drawer".
     cart.js / cart-drawer.js codent "cart-drawer" en dur : sans ce correctif,
     le rendu partiel renverrait la section avec ses réglages par défaut
     au lieu de ceux enregistrés par le marchand. */
  function drawerSectionId() {
    const wrapper = document.querySelector('cart-drawer')?.closest('.shopify-section');
    if (wrapper && wrapper.id.startsWith('shopify-section-')) {
      return wrapper.id.slice('shopify-section-'.length);
    }
    return 'cart-drawer';
  }

  /* Le remplacement du HTML remet la zone défilante en haut : on mémorise la
     position avant, on la restaure après. Sans ça, retirer un produit vu en bas
     du panier renvoie brutalement le client au sommet de la liste. */
  function captureScroll() {
    const body = document.querySelector('#CartDrawer .afs-body');
    return body ? body.scrollTop : null;
  }

  function restoreScroll(position) {
    if (position === null || position === undefined) return;
    const body = document.querySelector('#CartDrawer .afs-body');
    if (body) body.scrollTop = position;
  }

  /* renderContents() et refreshCartDrawer() réécrivent le tiroir : le lien de
     fermeture posé sur le voile est perdu à chaque fois. On le repose, en
     acceptant les deux écritures possibles du sélecteur. */
  function bindOverlay() {
    const drawer = drawerElement();
    if (!drawer) return;
    const overlay = drawer.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
    if (!overlay || overlay.dataset.afsBound === '1') return;
    overlay.dataset.afsBound = '1';
    overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  /* Rafraîchit tout l'intérieur du panier + la pastille du header. */
  function applyCartSections(sections) {
    if (!sections) return false;

    const scroll = captureScroll();
    const drawerHtml = sections[drawerSectionId()];
    const bubbleHtml = sections['cart-icon-bubble'];
    let updated = false;

    if (drawerHtml) {
      const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const newInner = doc.querySelector('.drawer__inner');
      const currentInner = document.querySelector('#CartDrawer .drawer__inner');
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = drawerElement();

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
        if (newDrawer && currentDrawer) {
          currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
        }
        restoreScroll(scroll);
        bindOverlay();
        updated = true;
      }
    }

    if (bubbleHtml) {
      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const source = bubbleDoc.querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (source && target) {
        target.innerHTML = source.innerHTML;
        updated = true;
      }
    }

    return updated;
  }

  /* Une seule requête récupère le tiroir et la pastille du header. */
  async function refreshCartDrawer() {
    const cartUrl = window.routes.cart_url;
    const sectionIds = [drawerSectionId(), 'cart-icon-bubble'];
    const params = new URLSearchParams({
      sections: sectionIds.join(','),
      sections_url: cartUrl,
    });

    try {
      const response = await fetch(`${cartUrl}?${params.toString()}`);
      if (response.ok) {
        const sections = await response.json();
        if (applyCartSections(sections)) return;
      }
    } catch (e) {
      /* Repli ci-dessous si le rendu groupé n'est pas disponible. */
    }

    /* Repli robuste : les deux rendus sont demandés en parallèle. */
    const [drawerResponse, bubbleResponse] = await Promise.all([
      fetch(`${cartUrl}?section_id=${drawerSectionId()}`),
      fetch(`${cartUrl}?section_id=cart-icon-bubble`),
    ]);
    const [drawerHtml, bubbleHtml] = await Promise.all([
      drawerResponse.text(),
      bubbleResponse.text(),
    ]);
    applyCartSections({
      [drawerSectionId()]: drawerHtml,
      'cart-icon-bubble': bubbleHtml,
    });
  }

  /* Les événements sans HTML groupé (intégrations tierces) se resynchronisent
     immédiatement. Dawn fournit déjà les sections dans sa réponse d'ajout. */
  function scheduleRefresh() {
    return refreshCartDrawer().catch((e) => console.error(e));
  }

  function cancelScheduledRefresh() {}


  customElements.whenDefined('cart-drawer-items').then(() => {
    const CartDrawerItems = customElements.get('cart-drawer-items');
    if (!CartDrawerItems) return;

    /* Le changement de quantité part dès l'événement change, sans le délai
       de saisie standard de Dawn dans le tiroir. */
    const originalConnectedCallback = CartDrawerItems.prototype.connectedCallback;
    if (typeof originalConnectedCallback === 'function') {
      CartDrawerItems.prototype.connectedCallback = function () {
        originalConnectedCallback.call(this);

        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'cart-items') return;
          if (event.cartData && event.cartData.sections) return;
          return this.onCartUpdate();
        });

        if (this.dataset.afsInstantQuantity !== 'true') {
          this.dataset.afsInstantQuantity = 'true';
          this.addEventListener('change', (event) => {
            if (!event.target.matches('.afs-qty__input')) return;
            event.stopImmediatePropagation();

            /* Affiche immédiatement le nouveau prix de ligne; Shopify renvoie
               ensuite le montant définitif avec remises et cadeaux recalculés. */
            const line = event.target.closest('.afs-item');
            const unitPrice = Number(line && line.dataset.afsUnitFinalPrice);
            const quantity = Math.max(0, parseInt(event.target.value, 10) || 0);
            const price = line && line.querySelector('.afs-item__price');
            if (price && Number.isFinite(unitPrice)) {
              const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
              const locale = document.documentElement.lang || 'fr-FR';
              try {
                price.textContent = new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency,
                }).format((unitPrice * quantity) / 100);
              } catch (error) {
                price.textContent = ((unitPrice * quantity) / 100).toFixed(2) + ' ' + currency;
              }
              line.classList.add('afs-item--optimistic');
            }
            this.onChange(event);
          }, true);
        }
      };
    }

    /* Changement de quantité / suppression : cart.js remplace #CartDrawer .drawer__inner. */
    CartDrawerItems.prototype.getSectionsToRender = function () {
      return [
        { id: 'CartDrawer', section: drawerSectionId(), selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    };

    /* Le rendu partiel natif ne remplace que cart-drawer-items et le footer,
       ce qui laisserait l'en-tête (pastille) périmée. On élargit au drawer entier. */
    CartDrawerItems.prototype.onCartUpdate = function () {
      return scheduleRefresh();
    };

    /* Descendre à 0 avec le bouton « − » doit retirer l'article, pas afficher
       « Cet article a un minimum de 1 ».

       Le champ porte min="0" (le bouton − reste donc actif à 1) mais aussi
       data-min="1", la règle de quantité Shopify par défaut. validateQuantity()
       compare la nouvelle valeur à data-min sans distinguer le cas 0 : la
       saisie est refusée et la ligne restaurée à 1, si bien que le seul moyen
       de retirer un article était la corbeille. Or 0 n'est pas une quantité
       invalide dans un panier — c'est une suppression, exactement ce que fait
       déjà cart-remove-button en appelant updateQuantity(index, 0). */
    const originalValidateQuantity = CartDrawerItems.prototype.validateQuantity;
    CartDrawerItems.prototype.validateQuantity = function (event) {
      if (parseInt(event.target.value, 10) === 0) {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          event.target.dataset.index,
          0,
          event,
          document.activeElement ? document.activeElement.getAttribute('name') : null,
          event.target.dataset.quantityVariantId
        );
        return;
      }
      return originalValidateQuantity.call(this, event);
    };

    /* +/− et suppression : on encadre l'appel natif pour afficher l'état
       d'attente léger et rendre la position de lecture. */
    const originalUpdateQuantity = CartDrawerItems.prototype.updateQuantity;
    CartDrawerItems.prototype.updateQuantity = function (...args) {
      const scroll = captureScroll();
      setBusy(true);

      const finish = () => {
        restoreScroll(scroll);
        bindOverlay();
        setBusy(false);
      };

      /* cart.js ne renvoie pas de promesse : on se raccroche à l'événement
         qu'il publie une fois les sections réécrites, avec un filet de
         sécurité si la requête échoue sans rien publier. */
      const safety = setTimeout(finish, 8000);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          unsubscribe();
          clearTimeout(safety);
          requestAnimationFrame(finish);
        });
      } else {
        clearTimeout(safety);
        setTimeout(finish, 600);
      }

      return originalUpdateQuantity.apply(this, args);
    };
  });

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer) return;

    /* Ajout au panier depuis une page produit : product-form lit cette liste
       pour demander les sections, puis renderContents les injecte. */
    CartDrawer.prototype.getSectionsToRender = function () {
      return [
        { id: drawerSectionId(), selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    };

    /* Moonbundle (offres groupées, cadeaux automatiques) modifie le panier sans
       événement thème → on resynchronise à l'ouverture, mais seulement sur une
       vraie transition fermé→ouvert (jamais si le panier est déjà ouvert, pour
       ne pas détruire la zone défilante en cours de lecture). */
    const originalOpen = CartDrawer.prototype.open;
    CartDrawer.prototype.open = function (triggeredBy) {
      const wasActive = this.classList.contains('active');
      originalOpen.call(this, triggeredBy);
      if (wasActive) return;
      if (this.afsSkipNextRefresh) {
        this.afsSkipNextRefresh = false;
        return;
      }
      refreshCartDrawer().catch((e) => console.error(e));
    };

    const originalRenderContents = CartDrawer.prototype.renderContents;
    CartDrawer.prototype.renderContents = function (parsedState) {
      this.afsSkipNextRefresh = true;
      cancelScheduledRefresh();

      try {
        originalRenderContents.call(this, parsedState);
      } catch (e) {
        /* renderContents pose un écouteur sur #CartDrawer-Overlay AVANT
           d'appeler open() : si une étape du rendu échoue, l'ouverture n'est
           jamais atteinte et le produit part au panier sans que le tiroir
           s'affiche. On avale l'erreur et on ouvre nous-mêmes juste en dessous. */
        console.error(e);
      }

      this.classList.remove('is-empty');
      bindOverlay();
      setTimeout(() => this.open());
    };
  });

  /* ================================================================
     Ajout rapide des vitrines (section featured-collection)
     ================================================================
     Le bouton « + » de cette section a son propre gestionnaire, écrit avant ce
     panier, et qui se trompe deux fois :

       1. il n'appelle jamais le tiroir — il émet `cart:refresh` / `cart:update`,
          des événements custom que rien dans le thème n'écoute ;
       2. il rafraîchit la pastille via
          `/?sections=cart-icon-bubble,cart-notification`, or cart-notification
          est un SNIPPET et non une section : l'API renvoie une erreur, le
          .json() échoue et le .catch() vide avale tout — pastille comprise.
          C'est pourquoi le compteur restait à zéro.

     On reprend la main en phase de capture, avant ce gestionnaire, pour passer
     par le circuit Dawn : /cart/add.js renvoie directement le HTML des sections
     demandées, que renderContents() injecte (tiroir ET pastille) avant
     d'ouvrir le panier.

     Le comportement des produits à variantes est laissé strictement inchangé :
     on rend la main au gestionnaire d'origine. */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.nfc-quick');
      if (!button) return;

      const drawer = drawerElement();
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      if (button.dataset.hasVariants === 'true') return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const label = button.textContent;
      button.textContent = '…';
      button.disabled = true;

      const restore = () => {
        button.textContent = label;
        button.disabled = false;
      };

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.routes.cart_url,
        }),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) throw new Error(state.description || state.message);

          /* La classe vit sur <cart-drawer>, que renderContents ne remplace pas :
             sans ça, le tiroir s'ouvrirait sur l'écran « panier vide » alors
             qu'il vient de recevoir un produit. */
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);

          /* source 'cart-items' : évite qu'un second aller-retour soit
             programmé pour un contenu déjà à jour. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
          }
          restore();
        })
        .catch((e) => {
          console.error(e);
          restore();
        });
    },
    true
  );

  /* ---------- Minuteur ---------- */
  const TIMER_KEY = 'afs-cart-timer-deadline';

  class CartTimer extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.afs-timer__text');
      this.template = this.dataset.template || '[minutes]';
      const minutes = parseInt(this.dataset.minutes, 10) || 10;

      let deadline = parseInt(sessionStorage.getItem(TIMER_KEY) || '', 10);
      if (!deadline || Number.isNaN(deadline) || deadline < Date.now()) {
        deadline = Date.now() + minutes * 60 * 1000;
        try {
          sessionStorage.setItem(TIMER_KEY, String(deadline));
        } catch (e) {
          /* navigation privée */
        }
      }
      this.deadline = deadline;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = Math.max(0, this.deadline - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      const ss = String(totalSeconds % 60).padStart(2, '0');
      if (this.textEl) this.textEl.textContent = this.template.replace('[minutes]', `${mm}:${ss}`);
      if (remaining <= 0) clearInterval(this.interval);
    }
  }
  if (!customElements.get('cart-timer')) customElements.define('cart-timer', CartTimer);

  /* ---------- Ventes additionnelles ---------- */
  class CartUpsells extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.counter = this.querySelector('[data-counter]');
      this.nav = this.querySelector('.afs-upsells__nav');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));

      if (this.nav && this.slides.length > 1) this.nav.setAttribute('data-multiple', '');

      this.querySelectorAll('.afs-upsells__arrow').forEach((button) => {
        button.addEventListener('click', () => this.move(button.dataset.direction === 'next' ? 1 : -1));
      });

      this.querySelectorAll('[data-upsell-add]').forEach((button) => {
        button.addEventListener('click', () => this.addToCart(button));
      });

      if (this.track) this.track.addEventListener('scroll', () => this.updateCounter(), { passive: true });
      this.updateCounter();
    }

    get index() {
      if (!this.track || !this.slides.length) return 0;
      const width = this.slides[0].offsetWidth + this.gap;
      return Math.round(this.track.scrollLeft / width);
    }

    get gap() {
      return parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
    }

    move(direction) {
      if (!this.track || !this.slides.length) return;
      const next = Math.min(Math.max(this.index + direction, 0), this.slides.length - 1);
      this.track.scrollTo({ left: next * (this.slides[0].offsetWidth + this.gap), behavior: 'smooth' });
    }

    updateCounter() {
      if (!this.counter || !this.slides.length) return;
      this.counter.textContent = `${Math.min(this.index + 1, this.slides.length)}/${this.slides.length}`;
      const prev = this.querySelector('[data-direction="prev"]');
      const next = this.querySelector('[data-direction="next"]');
      if (prev) prev.disabled = this.index <= 0;
      if (next) next.disabled = this.index >= this.slides.length - 1;
    }

    async addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;
      button.setAttribute('aria-busy', 'true');
      setBusy(true);

      try {
        const drawer = drawerElement();
        const sections = drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map((section) => section.id)
          : [];
        const response = await fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections,
            sections_url: window.routes.cart_url,
          }),
        });
        const result = await response.json();
        if (result.status) throw new Error(result.description || result.message);

        if (!applyCartSections(result.sections)) await refreshCartDrawer();
        /* source 'cart-items' : les autres éléments panier ne refont pas le fetch */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        }
      } catch (e) {
        console.error(e);
        button.removeAttribute('aria-busy');
      } finally {
        setBusy(false);
      }
    }
  }
  if (!customElements.get('cart-upsells')) customElements.define('cart-upsells', CartUpsells);

  /* ---------- Code promo ---------- */
  class CartDiscountForm extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-discount-input]');
      this.error = this.querySelector('[data-discount-error]');
      const button = this.querySelector('[data-discount-apply]');
      if (button) button.addEventListener('click', () => this.apply());
      if (this.input) {
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.apply();
          }
        });
      }
    }

    async apply() {
      const code = (this.input?.value || '').trim();
      if (!code) return;
      if (this.error) this.error.hidden = true;
      setBusy(true);

      try {
        const response = await fetch(`${window.routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const cart = await response.json();
        const applied = (cart.discount_codes || []).some(
          (entry) => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable
        );
        if (!applied && this.error) this.error.hidden = false;
        await refreshCartDrawer();
      } catch (e) {
        console.error(e);
        if (this.error) this.error.hidden = false;
      } finally {
        setBusy(false);
      }
    }
  }
  if (!customElements.get('cart-discount-form')) customElements.define('cart-discount-form', CartDiscountForm);
})();
